import { Outlet } from '@remix-run/react';
import { useQueryClient } from '@tanstack/react-query';
import { FC } from 'react';
import { SideOver, ttDetailsKeys } from '../..';

export type AccountDetailsLayoutProps = {
  exitRoute: string;
  baseRoute: string;
};

export const AccountDetailsLayoutPage: FC<AccountDetailsLayoutProps> = ({ exitRoute, baseRoute }) => {
  const queryClient = useQueryClient();

  return (
    <SideOver
      exitRoute={exitRoute}
      baseRoute={baseRoute}
      onExitComplete={() => {
        queryClient.invalidateQueries(ttDetailsKeys.base);
      }}
    >
      <Outlet />
    </SideOver>
  );
};
